The input parameter for the `updateWebhookSubscriptionDeliveryConfiguration` mutation.
